import { Theme } from '@mui/material';

export const mobiscrollPickerSx = (theme: Theme) => ({
  '& .mbsc-textfield-wrapper': {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
  },
  '& .mbsc-ios.mbsc-form-control-wrapper.mbsc-ltr:before ': {
    border: 'none',
  },
  '& .mbsc-ios.mbsc-form-control-wrapper.mbsc-ltr:after ': {
    border: 'none',
  },
  '& .mbsc-popup-buttonx': {
    color: theme.palette.primary.main,
  },
});
